// js/Component/AddressBook/AddContactModal.jsx
import React, { useState } from "react";
import toast from "react-hot-toast";
import { createPhoneContact } from "js/Api/index";
import { validateName, validatePhoneNumber } from "js/helpers/common_functions";

function AddContactModal({ addressBookId, onClose, onCreated }) {
    const [displayName, setDisplayName] = useState("");
    const [phoneNumberRaw, setPhoneNumberRaw] = useState("");
    const [file, setFile] = useState(null);
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        const nameResult = validateName(displayName);
        if (!nameResult.valid) {
            toast.error(nameResult.error);
            return;
        }
        const name = nameResult.value;
        const phoneResult = validatePhoneNumber(phoneNumberRaw);
        if (!phoneResult.valid) {
            toast.error(phoneResult.error);
            return;
        }
        const phone = phoneResult.value;

        setSaving(true);
        const res = await createPhoneContact(addressBookId, {
            displayName: name,
            phoneNumberRaw: phone,
            file,
        });
        setSaving(false);

        if (res.success) {
            toast.success(res.message || "Contact added");
            onCreated(res.data);
            onClose();
        } else {
            toast.error(res.error || "Failed to add contact");
        }
    };

    return (
        <div className="modal" role="dialog" style={{ display: "block" }}>
            <div className="modal-dialog" role="document">
                <div className="modal-content" style={{ width: 460 }}>
                    <div className="modal-header">
                        <h1 className="modal-title">Add Phone Contact</h1>
                        <button
                            className="close-button"
                            onClick={onClose}
                            disabled={saving}
                        >
                            &times;
                        </button>
                    </div>
                    <div className="modal-body">
                        <div style={{ marginBottom: 12 }}>
                            <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: "block" }}>
                                Name <span style={{ color: "#c44" }}>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={displayName}
                                onChange={(e) => setDisplayName(e.target.value)}
                                disabled={saving}
                                placeholder="e.g. Jane Smith"
                                autoFocus
                            />
                        </div>

                        <div style={{ marginBottom: 12 }}>
                            <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: "block" }}>
                                Phone Number <span style={{ color: "#c44" }}>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={phoneNumberRaw}
                                onChange={(e) => setPhoneNumberRaw(e.target.value)}
                                disabled={saving}
                                placeholder="+61 400 123 456"
                            />
                            <div
                                style={{
                                    fontSize: 12,
                                    color: "#666",
                                    marginTop: 4,
                                }}
                            >
                                Include country code, e.g. +61 400 123 456
                            </div>
                        </div>

                        <div style={{ marginBottom: 4 }}>
                            <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, display: "block" }}>
                                Avatar (optional)
                            </label>
                            <input
                                id="address-book-add-avatar"
                                type="file"
                                accept="image/png,image/jpeg"
                                onChange={(e) => setFile(e.target.files?.[0] || null)}
                                disabled={saving}
                                style={{ display: "none" }}
                            />
                            <label
                                htmlFor="address-book-add-avatar"
                                className="btn btn-sm btn-outline-secondary"
                                style={{ marginBottom: 0, cursor: saving ? "not-allowed" : "pointer" }}
                            >
                                {file ? "Change file" : "Choose file"}
                            </label>
                            {file && (
                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#666",
                                        marginTop: 6,
                                        wordBreak: "break-all",
                                    }}
                                >
                                    {file.name}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn cur-p btn-secondary"
                            onClick={onClose}
                            disabled={saving}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn cur-p btn-primary"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? "Saving..." : "Add Contact"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddContactModal;
